/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCategory = createReactComponent("category", "IconCategory", [
  ["path", { d: "M4 4h6v6h-6z", key: "svg-0" }],
  ["path", { d: "M14 4h6v6h-6z", key: "svg-1" }],
  ["path", { d: "M4 14h6v6h-6z", key: "svg-2" }],
  ["path", { d: "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-3" }]
]);

export { IconCategory as default };
//# sourceMappingURL=IconCategory.js.map
